import { post, get } from "@/api/http";
import profile from "./profile";
import main from "./main";

var serverLocation = main.getServerLocation();
const api2Rc = profile.apiUrl[serverLocation];
const fluidTokenUrl= api2Rc+"/service/generatetoken" //給azClient call Api用

export default {
  fluidTokenUrl,
  getMindMapSas: function () {
    return post("/mindmap/sas");
  },
  createMindMap: function (data) {
    return post("/mindmap/create-mindmap", data);
  },
  getMindMapsByTmid: function (data) {
    return post("/mindmap/get-mindmaps", data);
  },
  getMindMapByMid: function (data) {
    return post("/mindmap/get-mindmap-by-mid", data);
  },
  updateMindMap: function (data) {
    return post("/mindmap/update-mindmap", data);
  },
  deleteMindMap: function (data) {
    return post("/mindmap/delete-mindmap", data);
  },
  getFluidRelayConfig: function () {
      return post(api2Rc+"/area/serviceUrl");
  },
  getClipCode: function (data) {
    return post(api2Rc + "/Service/CreateClipCodes",data);
  },
  getOrigDataFromClipCode: function (data) {
    return post(api2Rc + "/Service/GetOrigDataFromClipCode",data);
  },

  //收集區的API
  createMindCollect: function (data) {
    return post("/mindcollect/create-mindcollect", data);
  },
  getMindCollectById: function (data) {
    return post("/mindcollect/get-mindcollect", data);
  },
  getMyMindCollects: function (data) {
    return post("/mindcollect/get-my-mindcollects", data);
  },
  updateMindCollect: function (data) {
    return post("/mindcollect/update-mindcollect", data);
  },
  deleteMindCollect: function (data) {
    return post("/mindcollect/delete-mindcollect", data);
  },
  deleteMindMaps: function (data) { //一次刪除多個mindmap 目前只有在刪除收集區時使用
    return post("/mindmap/delete-mindmaps", data);
  },
  saveMindClickHistory:function (data){
    return post("/mindmap/save-mind-history", data);
  },
  getMindClickHistory:function (data){
    return post("/mindmap/get-mind-history", data);
  },
  updateHistoryFavorite:function (data){
    return post("/mindmap/update-history-favorite", data);
  },
  getMindCollectNormalFoldersByTmid:function (data){
    return post("/mindmap/get-normal-folders", data);
  },
  createSubFolder: function (data) {
    return post("/mindcollect/create-subfolder", data);
  },
  renameSubFolder: function (data) {
    return post("/mindcollect/rename-subfolder", data);
  },
  deleteSubFolder: function (data) {
    return post("/mindcollect/delete-subfolder", data);
  },
  moveMindmapToFolder: function (data) {
    return post("/mindcollect/move-mindmap-to-folder", data);
  },
  checkPublicFeatureAccess: function(data) {
    return post("/mindmap/check-public-feature-access", data);
  },
  checkCopyMindMapAccess: function(data) {
    return post("/mindmap/check-copy-mindmap-access", data);
  },
  publishMindMap: function(data) {
    return post("/mindmap/publish-mindmap", data);
  },
  finalizePublicMindMap: function(data) {
    return post("/mindmap/finalize-public-mindmap", data);
  },
  updatePublicMindMap: function(data) {
    return post("/mindmap/update-public-mindmap", data);
  },
  deletePublicMindMap: function(data) {
    return post("/mindmap/delete-public-mindmap", data);
  },
  getPublicMindMaps: function(data) {
    return post("/mindmap/get-public-mindmaps", data);
  },
  getPublicMindMapData: function(data) {
    return post("/mindmap/get-public-mindmap-data", data);
  },
  getMyPublicMindMaps: function(data) {
    return post("/mindmap/get-my-public-mindmaps", data);
  },
  getMindMapTotalCount: function() {
    return get("/mindmap/get-mindmap-total-count");
  },
  trackView: function(data) {
    return post("/mindmap/track-view", data);
  }
};
